import { format as dateFormat } from 'date-fns';
import { enGB as en, he, de } from 'date-fns/locale';
import { LOCALE } from '../constants';

const locales = { en, he, de };

function format(date, formatStr = 'PP') {
  if (typeof date === 'string') {
    const [day, month, year] = date.split('/');

    return dateFormat(new Date(year, month - 1, day), formatStr, {
      locale: locales[LOCALE],
    });
  }

  try {
    return dateFormat(date, formatStr, {
      locale: locales[LOCALE],
    });
  } catch(error) {
    return;
  }
}

export default format;
